import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Menu from "./menu"

import "./header.scss"

const Header = ({ siteTitle }) => (
  <header>
    <div className="header-contents">
      <h1 className="site-title">
        <Link className="" to="/">
          {siteTitle}
        </Link>
      </h1>
      <Menu />
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
